import { getEnvironmentName } from 'utility/environment';

export const getDevRoot = () =>
  `https://${window.location.hostname.split('.')[0]}.localtest.me:8000`;

export const BENTOBOX_UPDATE_MARKETING_CONSENT_ENDPOINT =
  '/api/customers/marketing-consent/';

const BASE_BENTOBOX_ENDPOINT = '/api/reservations';

export const BENTOBOX_ACCOUNT_ENDPOINT = `${BASE_BENTOBOX_ENDPOINT}/account/`;

export const BENTOBOX_SAVE_CARD_ON_FILE_ENDPOINT = `${BASE_BENTOBOX_ENDPOINT}/save-card-on-file/`;

export const BENTOBOX_BOOKING_WITH_CARD_ON_FILE_ENDPOINT = `${BASE_BENTOBOX_ENDPOINT}/booking-with-card-on-file/`;

export const BENTOBOX_PAYMENT_CREDENTIALS_ENDPOINT = `${BASE_BENTOBOX_ENDPOINT}/payment-credentials/`;

export const BENTOBOX_PRE_DINING_ENDPOINT = `${BASE_BENTOBOX_ENDPOINT}/pre-dining/`;

export const BENTOBOX_INSTAGRAM_MEDIA_ENDPOINT = `${BASE_BENTOBOX_ENDPOINT}/instagram/media`;

export const BENTOBOX_CONFIG_ENDPOINT = `${BASE_BENTOBOX_ENDPOINT}/config/`;

export const BENTOBOX_BOOKING_ENDPOINT = `${BASE_BENTOBOX_ENDPOINT}/booking-cof/`;

export const getLocationBySlugEndpoint = (slug: string) =>
  `${BASE_BENTOBOX_ENDPOINT}/${slug}/`;

export const getNextableBaseUrl = () =>
  `https://${
    getEnvironmentName() === 'production' ? 'services' : 'services-dev'
  }.nextable.com`;

export const NEXTABLE_BOOKING_ENDPOINT = `${getNextableBaseUrl()}/api/v3/public/booking`;

export const NEXTABLE_AVAILABILITIES_ENDPOINT = `${NEXTABLE_BOOKING_ENDPOINT}/availability`;

export const NEXTABLE_BOOKING_ID_ENDPOINT = `${NEXTABLE_BOOKING_ENDPOINT}/:bookingId`;

export const NEXTABLE_WAITLIST_ENDPOINT = `${getNextableBaseUrl()}/api/v3/public/waitlist`;

export const NEXTABLE_WAITLIST_AVAILABILITIES_ENDPOINT = `${NEXTABLE_WAITLIST_ENDPOINT}/availability`;

export const NEXTABLE_WAITLIST_ID_ENDPOINT = `${NEXTABLE_WAITLIST_ENDPOINT}/:waitlistId`;

export const getBookingDetailsById = (bookingId: string) =>
  `${NEXTABLE_BOOKING_ENDPOINT}/${bookingId}`;

export const getConfirmBookingDetailsById = (bookingId: string) =>
  `${NEXTABLE_BOOKING_ENDPOINT}/${bookingId}/confirm`;

export const getWaitlistDetailsById = (waitlistId: string) =>
  `${NEXTABLE_WAITLIST_ENDPOINT}/${waitlistId}`;

const BASE_DINER_ENDPOINT = '/diner';

export const BEGIN_DINER_AUTH_ENDPOINT = `${BASE_DINER_ENDPOINT}/begin_auth`;

export const COMPLETE_DINER_LOGIN_ENDPOINT = `${BASE_DINER_ENDPOINT}/login`;

export const DINER_LOGOUT_ENDPOINT = `${BASE_DINER_ENDPOINT}/logout`;

export const GET_CURRENT_USER_ENDPOINT = `${BASE_DINER_ENDPOINT}/current_user`;

export const REMOVE_SAVED_PAYMENT_METHOD_ENDPOINT = `${BASE_DINER_ENDPOINT}/payment_methods`;

export const BASE_UNIVERSAL_MENU_ENDPOINT = '/api/universal_menus';

// =============================================
export const getMenuDetailsById = (menuId: string | number) =>
  `/api/menu/${menuId}`;
